module.exports = __webpack_public_path__ + "img/go_to_top.0fac2e21.png";